module.exports = __webpack_public_path__ + "media/Welcome.d3b1740d.mp4";